import z from 'zod';
import { MediaDtoSchema } from '../media/media.schema';
import { createUpdateZodSchema } from '../types/DateUtils.types';

export const AuthorDtoSchema = z.object({
  id: z.string().uuid(),
  firstName: z.string(),
  lastName: z.string(),
  description: z.string().nullish(),
  socialLinks: z.object({
    instagram: z.string().nullish(),
    x: z.string().nullish(),
    linkedIn: z.string().nullish(),
  }).nullish(),
  avatar: MediaDtoSchema.nullish(),
  // List of PageContentDto is kept as any to avoid circular dependency
  pageContents: z.array(z.any()).nullish(),
}).merge(createUpdateZodSchema);

export type AuthorDto = z.infer<typeof AuthorDtoSchema>;
